import { useContext } from "react";
import { AppContext } from "./AppContext";

const parseArray = (arr) => {
	const invArr = [...arr];
	invArr.pop();
	invArr.reverse();
	const newArr = [...arr, ...invArr];
	return newArr.join(";");
};

const parseColor = (s) => {
	s = s.split(",");
	s.pop();
	s.push("0)");
	return s.join(",");
};

const parseDuration = (s) => parseInt(s) * 2 + "s";

const Circle = ({ item, index, duration, isStatic }) => {
	const { x, y } = item;
	const labelName = isStatic ? "s-" : "a-";
	return (
		<ellipse
			cx={x[0]}
			cy={y[0]}
			ry="60%"
			rx="65%"
			fill={"url(#" + labelName + index + ")"}
		>
			{!isStatic && (
				<>
					<animate
						attributeName="cy"
						dur={duration}
						repeatCount="indefinite"
						values={parseArray(y)}
					/>
					<animate
						attributeName="cx"
						dur={duration}
						repeatCount="indefinite"
						values={parseArray(x)}
					/>
				</>
			)}
		</ellipse>
	);
};

const Definition = ({ item, index, duration, isStatic }) => {
	const labelName = isStatic ? "s-" : "a-";
	const { colors } = item;
	return (
		<radialGradient
			key={index}
			id={labelName + index}
			gradientUnits="objectBoundingBox"
			x1="0"
			y1="0"
			x2="100"
			y2="100"
		>
			<stop offset="0" stopColor={colors[0]}>
				{!isStatic && (
					<animate
						attributeName="stop-color"
						dur={duration}
						repeatCount="indefinite"
						values={parseArray(colors)}
					/>
				)}
			</stop>

			<stop
				offset="1"
				stop-color={parseColor(colors[0])}
				stop-opacity="0"
			></stop>
		</radialGradient>
	);
};

export default function SVGAnimator({ isStatic }) {
	const { bg, config, duration } = useContext(AppContext);
	const parsedDuration = parseDuration(duration);

	const circles = config.map((configItem, index) => {
		return (
			<Circle
				index={index}
				key={index}
				duration={parsedDuration}
				item={configItem}
				isStatic={isStatic}
			/>
		);
	});

	circles.reverse();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080">
			<defs>
				{config.map((configItem, index) => {
					return (
						<Definition
							duration={parsedDuration}
							index={index}
							key={index}
							bg={bg}
							item={configItem}
							isStatic={isStatic}
						/>
					);
				})}
			</defs>
			<rect fill={bg} width="100%" height="100%" />
			{circles}
		</svg>
	);
}
